import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSecurity = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 38,
	height: 38,
	viewBox: "0 0 38 38",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("g", {
			filter: "url(#filter0_d_live_map_security)",
			children: [
				/* @__PURE__ */ _jsx("rect", {
					width: 34,
					height: 34,
					rx: 17,
					fill: "currentColor"
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 1,
					y: 1,
					width: 32,
					height: 32,
					rx: 16,
					stroke: "white",
					strokeWidth: 2
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M10.2237 22.4369C10.2237 22.7758 10.5274 23.0495 10.9032 23.0495H23.0925C23.4684 23.0495 23.772 22.7758 23.772 22.4369V17.9764C23.772 14.6032 20.7396 11.8694 16.9979 11.8694C13.2561 11.8694 10.2237 14.6032 10.2237 17.9764V22.4369ZM11.7527 17.9764C11.7527 15.3651 14.1013 13.2477 16.9979 13.2477C19.8944 13.2477 22.2431 15.3651 22.2431 17.9764V21.6712H14.7044V18.3975C14.7044 18.2922 14.6089 18.2061 14.4921 18.2061H13.5577C13.4409 18.2061 13.3453 18.2922 13.3453 18.3975V21.6712H11.7527V17.9764ZM10.7312 13.1425L11.5722 12.3843C11.638 12.325 11.638 12.2274 11.5722 12.168L10.1302 10.8681C10.0983 10.8396 10.0552 10.8236 10.0103 10.8236C9.96533 10.8236 9.92221 10.8396 9.89028 10.8681L9.04935 11.6262C9.01774 11.655 9 11.6939 9 11.7344C9 11.7749 9.01774 11.8138 9.04935 11.8426L10.4913 13.1425C10.5571 13.2018 10.6633 13.2018 10.7312 13.1425ZM24.9506 11.6262L24.1097 10.8681C24.0778 10.8396 24.0346 10.8236 23.9897 10.8236C23.9448 10.8236 23.9017 10.8396 23.8697 10.8681L22.4278 12.168C22.3962 12.1968 22.3785 12.2357 22.3785 12.2762C22.3785 12.3167 22.3962 12.3556 22.4278 12.3843L23.2688 13.1425C23.3346 13.2018 23.4429 13.2018 23.5087 13.1425L24.9506 11.8426C25.0165 11.7813 25.0165 11.6856 24.9506 11.6262ZM23.7933 24.2748H10.2024C9.82658 24.2748 9.52291 24.5485 9.52291 24.8874V25.3468C9.52291 25.4311 9.59936 25.5 9.69279 25.5H24.3029C24.3964 25.5 24.4728 25.4311 24.4728 25.3468V24.8874C24.4728 24.5485 24.1692 24.2748 23.7933 24.2748ZM16.4033 10.6441H17.5925C17.6859 10.6441 17.7624 10.5752 17.7624 10.491V8.65315C17.7624 8.56892 17.6859 8.5 17.5925 8.5H16.4033C16.3098 8.5 16.2334 8.56892 16.2334 8.65315V10.491C16.2334 10.5752 16.3098 10.6441 16.4033 10.6441Z",
					fill: "white"
				})
			]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("filter", {
			id: "filter0_d_live_map_security",
			x: 0,
			y: 0,
			width: 37.4,
			height: 37.4,
			filterUnits: "userSpaceOnUse",
			colorInterpolationFilters: "sRGB",
			children: [
				/* @__PURE__ */ _jsx("feFlood", {
					floodOpacity: 0,
					result: "BackgroundImageFix"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					in: "SourceAlpha",
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
					result: "hardAlpha"
				}),
				/* @__PURE__ */ _jsx("feOffset", {
					dx: 2,
					dy: 2
				}),
				/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: .7 }),
				/* @__PURE__ */ _jsx("feComposite", {
					in2: "hardAlpha",
					operator: "out"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in2: "BackgroundImageFix",
					result: "effect1_dropShadow_live_map_security"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in: "SourceGraphic",
					in2: "effect1_dropShadow_live_map_security",
					result: "shape"
				})
			]
		}) })
	]
});
const ForwardRef = forwardRef(SvgSecurity);
export { ForwardRef as ReactComponent };
